import * as React from "react";
import { filter } from "lodash";

import type { IDrop } from "../../drops/api/drops.api";

interface IProps {
  drops?: IDrop[] | null;
}

/**
 * Gets the customer's active drops count
 */
const CustomerActiveDropsCount = ({ drops }: IProps) => {
  // If no drops were given return 0
  if (!drops) {
    return (
      <>
        0
      </>
    );
  }

  return (
    <>
      {filter(drops, { status: "active" }).length}
    </>
  );
};

export default CustomerActiveDropsCount;
